module.exports = __webpack_public_path__ + "media/images/med-edit-2ba564ae.svg";